import { Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import { Link, useLocation } from "react-router-dom";
import PermissionRestrictedComponent from "src/shared_components/PermissionRestrictedComponent";

const FloatingBar = ({ items, props }: { items: any[]; props?: any }) => {
  const location = useLocation(); // Get current pathname

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        backgroundColor: "#08163B",
        borderColor: "#08163B",
        borderRadius: "12px",
        padding: "6px 16px",
        boxShadow: "-11px 7px 40px 9px #0000000D",
        ...props,
        overflow: "auto",
      }}
    >
      {items.map((item) => {
        const isActive = location.pathname
          .toLowerCase()
          .startsWith(item.path.toLowerCase());
        return (
          <PermissionRestrictedComponent
            permission={item.requiredPermission}
            key={item.title}
          >
            <Tooltip title={item.title}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  cursor: "pointer",
                  padding: "8px 16px",
                  borderRadius: "24px",
                  backgroundColor: isActive ? "#2B867C" : "#08163B",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#2B867C",
                  },
                  transition: "background-color 0.3s ease, color 0.3s ease",
                }}
                component={Link}
                to={item.path}
              >
                {item.icon}
              </Box>
            </Tooltip>
          </PermissionRestrictedComponent>
        );
      })}
    </Box>
  );
};

export default FloatingBar;
